import React from 'react'
import './view.scss'

const RedirectPage = () => {
  return (
    <>
      <h2 style={{ textAlign: 'center' }}>LOADING...</h2>
      <div className="loaderRedirect"></div>
    </>
  )
}
export default RedirectPage
